import styled from 'styled-components';
import { Collapse } from 'antd';
import { UpOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

export const FaqTitle = styled.h2`
  font-size: 1.5em;
  text-align: center;
  color: black;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
`;

export const StyledCollapse = styled(Collapse)`
   background-color: #fff;
`;

export const StyledPanel = styled(Panel)`
  display: block;
  justify-content: space-between;
  align-items: center;
  margin: 1em 0 1em;
  padding: 1em 1em;
  border-radius: 1em!important;
  border-bottom: 0!important;
  background-color: #f4f4f4;
  .ant-collapse-header-text {
    font-weight: 650;
    text-align: left;
    max-width: 95%;
  }
  p {
    font-size: 13px;
  }`;

export const StyledUpOutlined = styled(UpOutlined)`
  width: 2.5em;
  height: 2.5em;
  padding-top: 30%;
  border-radius: 5em;
  background-color: #e8e8e8;`;
